/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Quill from 'quill';
const Inline = Quill.import('blots/inline');

/**
 * A custom blot for links that allows for a title attribute.
 */
class CustomLinkBlot extends Inline {
  static create(value) {
    if (!value) {
      return super.create(false);
    }

    const node = super.create();
    let newValue;
    // Check if given value is a JSON string.
    if (isStringified(value)) {
      newValue = JSON.parse(value);
    } else {
      newValue = value;
    }

    if (typeof newValue !== 'string') {
      node.setAttribute('href', newValue.href);
      if (newValue.title) {
        node.setAttribute('title', newValue.title);
      }
    } else {
      node.setAttribute('href', newValue);
    }

    return node;
  }

  static formats(domNode) {
    return JSON.stringify({
      href: domNode.getAttribute('href'),
      title: domNode.getAttribute('title')
    });
  }

  format(name, value) {
    if (name !== this.statics.blotName || !value) {
      return super.format(name, value);
    }

    let newValue;

    if (isStringified(value)) {
      newValue = JSON.parse(value);
    } else {
      newValue = value;
    }
    if (typeof newValue !== 'string') {
      this.domNode.setAttribute('href', newValue.href);
      this.domNode.setAttribute('title', newValue.title);
    } else {
      this.domNode.setAttribute('href', newValue);
    }
  }
}

function isStringified(value) {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
}

CustomLinkBlot.tagName = 'A';
CustomLinkBlot.blotName = 'customLink';
CustomLinkBlot.SANITIZED_URL = 'about:blank';
CustomLinkBlot.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

Quill.register('formats/customLink', CustomLinkBlot, true);

export default CustomLinkBlot;
